import { atomFamily, atomWithRefresh } from "jotai/utils";

import { Logger } from "@moment/logging";

import { $docsApi } from "../../_interop";
import { $accessTokenFunc } from "../../authenication";
import { $remoteWorkspaceName } from "../current-document.atom";

const logger = new Logger("sync/docsapi.atom");

export const $remoteDocumentMetadataExists = atomFamily((documentId: string | undefined) =>
	atomWithRefresh(async (get) => {
		try {
			const tokenObject = get($accessTokenFunc);
			if (!tokenObject?.getAccessTokenSilently) {
				return false;
			}
			const accessToken = await tokenObject.getAccessTokenSilently();
			if (!accessToken) {
				return false;
			}
			if (!documentId) {
				return false;
			}

			const workspaceName = await get($remoteWorkspaceName(documentId));
			if (!workspaceName) {
				return false;
			}
			const docsApi = get($docsApi);
			return await docsApi.document.remoteMetadataExists(
				{ workspaceName, documentId },
				accessToken
			);
		} catch (error) {
			logger.error("Failed to check remote document metadata exists", { error });
			return false;
		}
	})
);
